var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTimerStart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 27.5C23.18 27.5 22.5 26.82 22.5 26V16C22.5 15.18 23.18 14.5 24 14.5C24.82 14.5 25.5 15.18 25.5 16V26C25.5 26.82 24.82 27.5 24 27.5Z",
    fill: "#455CC7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24 45.5C13.52 45.5 5 36.98 5 26.5C5 16.02 13.52 7.5 24 7.5C34.48 7.5 43 16.02 43 26.5C43 27.32 42.32 28 41.5 28C40.68 28 40 27.32 40 26.5C40 17.68 32.82 10.5 24 10.5C15.18 10.5 8 17.68 8 26.5C8 35.32 15.18 42.5 24 42.5C24.82 42.5 25.5 43.18 25.5 44C25.5 44.82 24.82 45.5 24 45.5Z",
    fill: "#455CC7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30 5.5H18C17.18 5.5 16.5 4.82 16.5 4C16.5 3.18 17.18 2.5 18 2.5H30C30.82 2.5 31.5 3.18 31.5 4C31.5 4.82 30.82 5.5 30 5.5Z",
    fill: "#455CC7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M32.3 44.0396C31.6 44.0396 30.96 43.8796 30.38 43.5396C29.06 42.7796 28.3 41.2396 28.3 39.3196V34.6996C28.3 32.7796 29.06 31.2396 30.38 30.4796C31.7 29.7196 33.4 29.8396 35.06 30.7796L39.06 33.0996C40.72 34.0596 41.68 35.4796 41.68 36.9996C41.68 38.5196 40.72 39.9396 39.06 40.8996L35.06 43.2196C34.14 43.7596 33.2 44.0396 32.3 44.0396ZM32.32 32.9596C32.16 32.9596 32 32.9996 31.88 33.0596C31.52 33.2596 31.3 33.8796 31.3 34.6796V39.2996C31.3 40.0996 31.52 40.7196 31.88 40.9196C32.24 41.1196 32.88 41.0196 33.56 40.6196L37.56 38.2996C38.26 37.8996 38.68 37.3996 38.68 36.9996C38.68 36.5996 38.26 36.0996 37.56 35.6996L33.56 33.3796C33.1 33.0996 32.66 32.9596 32.32 32.9596Z",
    fill: "#455CC7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimerStart);
export default __webpack_public_path__ + "static/media/TimerStart.d2653785.svg";
export { ForwardRef as ReactComponent };